/**
 * Plancher d'un trailing drawdown, point par point de la courbe de solde.
 *
 * Même règle que `computeBufferStatus` (propFirmEngine.ts) : plancher = pic - drawdown,
 * le pic ne redescend jamais et ne passe pas sous le solde initial. Le pic est
 * lu sur les soldes de CLÔTURE quotidiens de la courbe : exact pour un trailing
 * EOD, borne basse pour un intraday (un pic atteint en séance puis rendu n'y
 * figure pas).
 *
 * `enginePeak` (le `highWaterMark` du moteur) relève le dernier point : le pic
 * stocké peut dépasser les clôtures (intraday, solde broker).
 *
 * `floorCap` (le `floorAmount` du moteur) applique le gel du plancher
 * (drawdownLock.ts). Sans payout, le plancher gelé vaut `min(pic - drawdown,
 * niveau)` avec un pic croissant : plafonner chaque point au plancher final
 * donne donc exactement la courbe gelée.
 */
export function trailingFloorSeries(
  balances: number[],
  { initialBalance, maxDrawdown, enginePeak, floorCap }: {
    initialBalance: number;
    maxDrawdown: number;
    enginePeak?: number | null;
    floorCap?: number | null;
  },
): number[] {
  let peak = initialBalance;
  const cap = floorCap != null && Number.isFinite(floorCap) ? floorCap : Infinity;
  return balances.map((b, i) => {
    peak = Math.max(peak, b);
    if (i === balances.length - 1 && enginePeak != null && Number.isFinite(enginePeak)) peak = Math.max(peak, enginePeak);
    return Math.min(peak - maxDrawdown, cap);
  });
}
